/**
 * UI-only renames for contract names returned by Blockscout / bytecode DB.
 * Proxy bytecode is often matched to a generic template labeled "FinzoCrowd";
 * this explorer prefers "AdminProxy" in the UI.
 */
export function mapContractDisplayName(name: string | null | undefined): string | null | undefined {
  if (name === null || name === undefined) {
    return name;
  }
  if (name === 'FinzoCrowd') {
    return 'AdminProxy';
  }
  if (name === 'WKPG9') {
    return 'WDSC';
  }
  return name;
}
